import { css } from '@emotion/react'

export interface SistemaExternoIframeProps {
  nome: string
  url: string
}

export function SistemaExternoIframe(props: Readonly<SistemaExternoIframeProps>) {
  const { nome, url } = props

  if (!url) return null

  return <iframe css={styles.iframe} src={url} title={nome} referrerPolicy='strict-origin' />
}

export const sistemaExternoIframeStyles = {
  iframe: css`
    width: 100%;
    margin: 0rem;
    padding: 0rem;
    height: max(calc(100vh - 25rem), 68rem);
    border: none;
  `,
  reloadButton: css`
    padding: 0rem 0.5rem;
  `,
}

const styles = sistemaExternoIframeStyles
